"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextToHighlight = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var fuzz = _interopRequireWildcard(require("fuzzball"));

var _lodash = require("lodash");

var getSpanText = function getSpanText(data) {
  if (typeof data !== 'object' || !data) {
    return '';
  }

  return data.text.toLowerCase();
};

var getPossibleMatches = function getPossibleMatches(searchData, searchText) {
  var results = [];
  var preprocessedSearchText = fuzz.full_process(searchText);

  for (var _i = 0, _Object$entries = Object.entries(searchData); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
        groupData = _Object$entries$_i[1];

    var _iterator = (0, _createForOfIteratorHelper2.default)(groupData.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
            data = _step$value[1];

        var spanText = getSpanText(data);
        var score = fuzz.partial_token_similarity_sort_ratio(preprocessedSearchText, spanText);
        var scoreAddition = 0;

        if (spanText.length > searchText.length) {
          scoreAddition = searchText.length / spanText.length;
        } else if (spanText.length < searchText.length) {
          scoreAddition = -score * (1 - spanText.length / searchText.length);
        }

        results.push({
          score: (0, _lodash.clamp)(score + scoreAddition, 0, 100),
          data: data
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return results.sort(function (a, b) {
    return b.score - a.score;
  });
}; // MAIN


var getTextToHighlight = function getTextToHighlight(searchData, searchText) {
  try {
    var possibleMatches = getPossibleMatches(searchData, searchText);
    if (!possibleMatches.length) return [];
    var rowIds = [possibleMatches[0].data.rowId];

    for (var i = 1; i < possibleMatches.length; i++) {
      var match = possibleMatches[i];

      if (match.score === possibleMatches[0].score) {
        rowIds.push(match.data.rowId);
      } else {
        break;
      }
    }

    return rowIds;
  } catch (error) {
    console.error('[getTextToHighlight] error: ', error);
    return [];
  }
};

exports.getTextToHighlight = getTextToHighlight;